export class ResponseModel {
    isSuccess: boolean;
    message: string;
    data: any;
    dataCount: number;
    exception: object;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/response.model.ts